var $8d0d4739a5ca5496$exports = {};
$8d0d4739a5ca5496$exports = {
    "close": `Bez\xe1r\xe1s`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \xe9rtes\xedt\xe9s`,
            other: ()=>`${formatter.number(args.count)} \xe9rtes\xedt\xe9s`
        })}.`
};


export {$8d0d4739a5ca5496$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
